import React, { useEffect, useState } from 'react';

const AutoComplete = ({ data, handleChange, name, adminStyle,val }) => {
  const [inputValue, setInputValue] = useState(val);
  const [filteredData, setFilteredData] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isAdminStyle,setAdminStyle] = useState(false);

  useEffect(() => {
    setAdminStyle(adminStyle);
  }, [adminStyle]);

  useEffect(() => {
    if (val !== null && val !== undefined) {
      setInputValue(val);
    }
  }, [val]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // console.log('**&*^&^&^&^&^*&^***',e.target.value)
    setInputValue(value);

    // Update the form data with the input value
    handleChange(e);

    // Filter the data based on input
    if (value) {
      const filtered = data.filter((item) =>
        item.collegeName.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredData(filtered);
      setShowDropdown(true);
    } else {
      setShowDropdown(false);
    }
  };

  const handleSelect = (college) => {
    setInputValue(college.collegeName);
    setShowDropdown(false);
    // console.log("#######",college.id)
    // Manually trigger handleChange to update formData with the selected college ID
    handleChange({
      target: { name: "collegeName", value: college
       },
    });
  };

  return (
    <div className="autocomplete" style={{ position: 'relative' }}>
      <input
        type="text"
        value={inputValue}
        name={name}  // Ensure the name is passed correctly
        onChange={handleInputChange}
        className= {!isAdminStyle ? "border-b p-2 w-full  border-blue-300" : "border rounded p-2 mb-2 md:mb-0 w-full md:mr-2"}
        placeholder="Type to search for a college..."
      />

      {showDropdown && filteredData.length > 0 && (
        <ul
          className="absolute z-10 border mt-1 p-2 max-h-40 overflow-y-auto bg-white w-full"
          style={{ top: '100%' }}
        >
          {filteredData.map((college) => (
            <li
              key={college.id}
              className="cursor-pointer p-1 hover:bg-gray-200"
              onClick={() => handleSelect(college)}
            >
              {college.collegeName}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AutoComplete;
